//App constants for client-side
export const APP_DATE_FORMAT = 'MM/dd/yyyy';
export const APP_TIME_FORMAT = 'hh:mm a'
export const APP_STORAGE_TOKEN = 'AuthToken';
export const APP_STORAGE_USERNAME = 'userName';
export const APP_STORAGE_FIRSTNAME = 'firstName';
export const APP_STORAGE_REMEMBERME = 'rememberMe';

//Miscellaneous
export const MIN_CHAR_SEARCH_LENGTH = 3;

export const MIN_YEAR = 2000;
export const MAX_YEAR = 2030;

export const PRINT_BTN = '<i class="fa fa-print"></i>';
export const EDIT_BTN = '<i class="fa fa-pencil"></i>';
export const VIEW_BTN = '<i class="fa fa-eye"></i>';
export const SINGLE_ROW_HEADER = 35;
export const DOUBLE_ROW_HEADER = 57;
export const TRIPLE_ROW_HEADER = 79;
export const OVERDUE_BTN = '<i class="fa fa-exclamation-triangle"></i>';
export const AUDIT_BTN = '<i class="fa fa-clock-o"></i>';
export const DELETE_BTN = '<i class="fa fa-trash"></i>';
export const UPLOAD_BTN = '<i class="fa fa-upload"></i>';
export const DOWNLOAD_BTN = '<i class="fa fa-download"></i>';

// Audit
export const AUDIT_ENTITY_ID = 'auditEnitiyId';
export const AUDIT_ENTITY_TYPE = 'auditEnitiyType';
export const AUDIT_ENTITY_COLUMN_DEFS = 'auditEnitiyColumnDefs';
export const AUDIT_PAGE_TITLE = 'auditPageTitle';
export const PAGE_ID = 'pageId';



// WEBPACK FOOTER //
// ./src/app/shared/constants/application.constants.ts